<template>
  <v-container>
    <div id="headersTime">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacao"
                  style="text-align: center;"
                />
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Estrutura Organizacional
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Faturamento
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Meta de Faturamento
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Atigimento do Fat.
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  GAP de Fat. por Meta
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Tendência do Fat.
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Atingimento da Tendência
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                >
                  Margem Contribuição
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in evolucaoTimeSupervisor"
              :key="item.id"
            >
              <!-- Linha principal -->
              <tr>
                <td style="text-align: center;">
                  <button @click="toggleExpand(index)">
                    {{ expanded.includes(index) ? '▲' : '▼' }}
                  </button>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.meta }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColor(item.variacao_faturamento)"
                    dark
                  >
                    {{ item.variacao_faturamento }}
                  </v-chip>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.gap_faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.tendencia }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColor(item.variacao_tendencia)"
                    dark
                  >
                    {{ item.variacao_tendencia }}
                  </v-chip>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  <v-chip
                    :color="getColorMargemContribuicao(item.margemContribuicao)"
                    dark
                  >
                    {{ item.margemContribuicao }}
                  </v-chip>
                </td>
              </tr>
              <!-- Linha expandida -->
              <tr
                v-if="expanded.includes(index)"
                :key="'expanded-' + item.id"
              >
                <td colspan="9">
                  <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                    <thead>
                      <tr>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Estrutura Organizacional
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Faturamento
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Meta de Faturamento
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Atigimento do Fat.
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          GAP de Fat. por Meta
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Tendência do Fat.
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Atingimento da Tendência
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Margem Contribuição
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(sub, idx) in item.evolucaoVendedores"
                        :key="idx"
                      >
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ sub.nome }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.faturamento }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.meta }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          <v-chip
                            :color="getColor(sub.variacao_faturamento)"
                            dark
                          >
                            {{ sub.variacao_faturamento }}
                          </v-chip>
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.gap_faturamento }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.tendencia }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          <v-chip
                            :color="getColor(sub.variacao_tendencia)"
                            dark
                          >
                            {{ sub.variacao_tendencia }}
                          </v-chip>
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          <v-chip
                            :color="getColorMargemContribuicao(sub.margemContribuicao)"
                            dark
                          >
                            {{ sub.margemContribuicao }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Time from '../../../../../services/time3'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: ['updateProgressoTime'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectIcon: {
        color: '#4780b8',
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      segmento: [],
      expanded: [],
      rede: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      vendedor: [],
      evolucaoTimeSupervisor: [],
      evolucaoTimeVendedores: [],
      expandDetalhamento: false,
      icone: 'mdi-plus',
      expandVendedores: false,
    }),

    created () {
      eventEmit.$on('update-time', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-time', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, classificacao, vendedores) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.vendedor = vendedores

        this.evolucaoTimeSupervisor = []
        this.expanded = []
        this.showEvolucaoSupervisor()
      },

      async showEvolucaoSupervisor () {
        this.loading = true

        await Time.showDadosEvolucaoTime3(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.classificacao, this.vendedor).then(resposta => {
          if (resposta.data.status) {
            const setPerson = new Set()

            const filterSupervisores = resposta.data.evolucaoTimeSupervisor.filter((person) => {
              const duplicatedPerson = setPerson.has(person.nome_supervisor)
              setPerson.add(person.nome_supervisor)
              return !duplicatedPerson
            })

            this.evolucaoTimeSupervisor = filterSupervisores.map((item) => {
              var listaFaturamentoSupervisor = ({
                nome: item.nome_supervisor,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamentoEnviar: parseFloat(item.faturamento),
                meta: parseFloat(item.meta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                metaEnviar: parseFloat(item.meta),
                variacao_faturamento: item.variacao_faturamento + '%',
                gap_faturamento: item.gap_faturamento < 0 ? '(' + parseFloat(-item.gap_faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ')' : parseFloat(item.gap_faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                tendencia: parseFloat(item.tendencia).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao_tendencia: item.variacao_tendencia + '%',
                cod_supervisor: item.cod_supervisor,
                quantidade: item.quantidade.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                cmv: item.quantidade.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemContribuicao: item.margemContribuicao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                icone: item.icone,
                expandir: item.expandir,
                evolucaoVendedores: this.orderVendedores(item.evolucaoVendedores),
              })

              return listaFaturamentoSupervisor
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.evolucaoVendasSupervisor = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      orderVendedores (value) {
        const setPerson = new Set()

        const filterVendedores = value.filter((person) => {
          const duplicatedPerson = setPerson.has(person.nome)
          setPerson.add(person.nome)
          return !duplicatedPerson
        })

        const vendedores = filterVendedores.map((item) => {
          var listaFaturamentoVendedores = ({
            nome: item.nome,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            meta: parseFloat(item.meta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_faturamento: item.variacao_faturamento + '%',
            gap_faturamento: item.gap_faturamento < 0 ? '(' + parseFloat(-item.gap_faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ')' : parseFloat(item.gap_faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            tendencia: parseFloat(item.tendencia).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            variacao_tendencia: item.variacao_tendencia + '%',
            cod_supervisor: item.cod_supervisor,
            quantidade: item.quantidade.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            cmv: item.quantidade.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemContribuicao: item.margemContribuicao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
          })

          return listaFaturamentoVendedores
        })

        return vendedores
      },

      getColor (value) {
        var porcentagem = value.replace('%', '')

        porcentagem = parseFloat(porcentagem.replace('.', '').replace(',', '.'))

        if (porcentagem < parseFloat(90)) {
          return 'red'
        } else if (porcentagem >= parseFloat(90)) {
          return 'green'
        }
      },

      getColorMargemContribuicao (value) {
        var porcentagem = value.replace('%', '')

        porcentagem = parseFloat(porcentagem.replace('.', '').replace(',', '.'))

        if (porcentagem < parseFloat(0)) {
          return 'red'
        } else if (porcentagem >= parseFloat(0)) {
          return 'green'
        }
      },

      expandedVendedores (value) {
        if (value.icone === 'mdi-plus') {
          value.expandir = true
          value.icone = 'mdi-minus'
        } else {
          value.icone = 'mdi-plus'
          value.expandir = false
        }
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersTime {
      font-size: 9px;
      width: 100% !important;
    }

    .tr-max {
      display:none;
    }
    .tr-min {
      display:table;
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersTime {
      font-size: 9px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #headersTime
    font-size: 9px

  .tr-min
    display:none

</style>
